import React, { useState, useContext, useEffect } from "react";
import axios from "axios";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Rating,
  Button,
  Select,
  MenuItem,
  IconButton,
  Tooltip,
  LinearProgress,
  useMediaQuery,
  Pagination,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import { UserContext } from "../../context/userContext/userContext";
import { useStyle } from "../../context/styleContext/styleContext";
import SubscribeRedirectModal from "../../components/SubscribeRedirectModal/SubscribeRedirectModal";
import LoginRegisterModal from "./LoginRegisterModal";
import LeaveReviewModal from "./leaveReviewModal";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";

const REVIEWS_PER_PAGE = 3;

export default function ProductReviewPage() {
  const { user } = useContext(UserContext);
  const { style } = useStyle();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [reviews, setReviews] = useState([]);
  const [productSKU, setProductSKU] = useState(null);
  const [productData, setProductData] = useState(null);
  const [filter, setFilter] = useState("all");
  const [sort, setSort] = useState("recent");
  const [currentPage, setCurrentPage] = useState(1);
  const [ratingsBreakdown, setRatingsBreakdown] = useState({});
  const [averageRating, setAverageRating] = useState(0);

  const [isSubscribeRedirectModalOpen, setSubscribeRedirectModalOpen] = useState(false);
  const [isLoginRegisterModalOpen, setLoginRegisterModalOpen] = useState(false);
  const [isLeaveReviewModalOpen, setLeaveReviewModalOpen] = useState(false);

  const [isLoginComplete, setIsLoginComplete] = useState(false); 
  const openModal = setModalFn => () => setModalFn(true);
  const closeModal = setModalFn => () => setModalFn(false);

  const [storedReviewId, setStoredReviewId] = useState()
  const [storedVote, setStoredVote] = useState()

  const loginCallback = async () => {

    setIsLoginComplete(true);

    const token = localStorage.getItem('token')
    if(!token)
    {
      console.log("NO TOKEN")
      return
    }

    const res = await axios.post("/api/mark_review", {
      token,
      reviewId:storedReviewId,
      type:storedVote,
    });

    getReviews();
    setLoginRegisterModalOpen(false);
    console.log("FINISHED!!")
  };

  const openLeaveReviewModal = () => setLeaveReviewModalOpen(true);
  const [height, setHeight] = useState(window.innerHeight)
  
  useEffect(() => {
    document.title = "Parish Audio | Reviews";
    getReviews();
  }, [filter, sort]);

  const getReviews = async () => {
    const productURI = window.location.pathname.split("/").pop();
    const { data: productInfo } = await axios.post("/get_product_by_uri", { productURI });

    if (!productInfo) return;

    setProductSKU(productInfo.SKU);
    setProductData(productInfo);

    const res = await axios.post("/get_all_product_reviews", {
      productSKU: productInfo.SKU,
      filter,
      sort,
    });

    const reviews = res.data || [];
    setReviews(reviews);

    const starCounts = [0, 0, 0, 0, 0]; // index 0 = 5 stars, index 4 = 1 star
    let total = 0;
    let sum = 0;

    reviews.forEach((r) => {
      const index = 5 - r.starRating;
      starCounts[index] = (starCounts[index] || 0) + 1;
      total++;
      sum += r.starRating;
    });

    const average = total ? (sum / total).toFixed(1) : 0;
    setAverageRating(average);
    setRatingsBreakdown(starCounts);
  };

  const handleVote = async (reviewId, type) => {

    const token = localStorage.getItem('token');
    if (!token ) {
      setStoredVote(type);
      setStoredReviewId(reviewId);
      setLoginRegisterModalOpen(true);
      return;
    }
    if (!user ) {
      setStoredVote(type);
      setStoredReviewId(reviewId);
      setLoginRegisterModalOpen(true);
      return;
    }

    const res = await axios.post("/api/mark_review", {
      token,
      reviewId,
      type,
    });

    getReviews();
    // getReviews();
  };


  const formatDate = (dateStr) => {
    const options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(dateStr).toLocaleDateString(undefined, options);
  };

  const filteredReviews = filter === "all"
    ? reviews
    : reviews.filter(r => r.starRating === filter);

  const totalPages = Math.ceil(filteredReviews.length / REVIEWS_PER_PAGE);
  const paginatedReviews = filteredReviews.slice(
    (currentPage - 1) * REVIEWS_PER_PAGE,
    currentPage * REVIEWS_PER_PAGE
  );

  return (
    <>
      {!productSKU ? (
        <Box sx={{ minHeight: "80vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
          <LoadingSpinner />
        </Box>
      ) : (
        <Box sx={{ maxWidth: 1000, margin: "auto", padding: 2, minHeight:height - 170, }}>
          {/* Header */}
          <Box
            sx={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              gap: 2,
              backgroundColor:style.color1,
              borderRadius:'8px',
              alignItems: isMobile ? "center" : "flex-start",
              
            }}
          >
            {/* Product Thumbnail */}
            <Box
              sx={{
                width: isMobile ? "auto" : "40%",
                height: isMobile ? "auto" : "100%",
                borderRadius: 2,
                //border: `1px solid ${style.color2}`,
                overflow: "hidden",
                textAlign:'center',
                padding:'10px',
                
                
              }}
            >
              <a href={'/products/'+ productData.productURI}>
              <img
                src={productData.images[0].URI}
                alt={productData.images[0].altText}
                style={{
                  
                  height: isMobile ? "auto" : "auto",
                  objectFit: "cover",
                  borderRadius: 8,
                  maxHeight:'230px',
                  maxWidth:'90%',
                  width:'auto',
                  margin:'auto',
                }}
              />
              </a>
              <h2 style={{marginTop:'10px', fontSize:'1.2em', color:style.color3}}>{productData.name}</h2>
            </Box>

            {/* Average Rating & Filters */}
            <Box
              sx={{
                flexGrow: 1,
                backgroundColor:style.color1,
                borderRadius: 2,
                padding: 1,
                width: isMobile ? "95%" : "95%",
                color:style.color4,
              }}
            >
              <Box sx={{ display:'flex', flexDirection:'column'}}>
              </Box>
              <h1 style={{marginTop:'10px'}}>Reviews</h1>
              <Box sx={{ display: "flex", alignItems: "center", mb: 1, gap: 2 }}>
                <Rating value={parseFloat(averageRating)} precision={0.1} readOnly />
                <Typography variant="h6">{averageRating} / 5</Typography>
              </Box>
              {/* Breakdown Chart */}
              {ratingsBreakdown &&
                [5, 4, 3, 2, 1].map((star, i) => {
                  const count = ratingsBreakdown[5 - star] || 0;
                  const percent = reviews.length ? (count / reviews.length) * 100 : 0;
                  return (
                    <Box key={star} sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                      <Typography sx={{ width: 40 }}>{star} ★</Typography>
                      <LinearProgress
                        variant="determinate"
                        value={percent}
                        sx={{ flexGrow: 1, height: 10, borderRadius: 5 }}
                      />
                      <Typography sx={{ width: 30 }}>{count}</Typography>
                    </Box>
                  );
                })}

              {/* Filter / Sort */}
              <Box sx={{ display: "flex", mt: 2, pb:1, flexDirection: isMobile ? "column" : "row", }}>
              <Button size='small' onClick={openLeaveReviewModal} sx={{minWidth:'150px',ml:1, mb:2, color: style.color4, display: 'block', boxShadow:5, backgroundColor: style.color1, filter: 'brightness(1.2)', fontSize: '12pt',  marginTop: '0px', borderColor: style.color2, borderWidth: '1px', borderStyle: 'solid', '&:hover': { backgroundColor: style.color2 } }}>Leave Review</Button>
              <Select
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
                size="small"
                
                sx={{
                  color: style.color4,
                  boxShadow:10,
                  ml:1,
                  mb:2,
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: style.color2,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: style.color3,
                  },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: style.color3,
                  },
                  '& .MuiSelect-icon': {
                    color: style.color4, // This changes the dropdown arrow
                  },
                }}
              >
                <MenuItem value="all">All Ratings</MenuItem>
                {[5, 4, 3, 2, 1].map(num => (
                  <MenuItem key={num} value={num}>{num} Stars</MenuItem>
                ))}
              </Select>
                <Select sx={{
                  color: style.color4,
                  ml:1,
                  boxShadow:10,
                  size:'small',
                  mb:2,
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: style.color2,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: style.color3,
                  },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: style.color3,
                  },
                  '& .MuiSelect-icon': {
                    color: style.color4, // This changes the dropdown arrow
                  },
                }}
                 value={sort} onChange={(e) => setSort(e.target.value)} size="small">
                  <MenuItem value="recent">Most Recent</MenuItem>
                  <MenuItem value="helpful">Most Helpful</MenuItem>
                </Select>
                </Box>
            </Box>
          </Box>

          {/* Reviews */}
          <Box mt={4}>
            {paginatedReviews.length === 0 ? (
              <Typography variant="body1">No reviews yet.</Typography>
            ) : (
              paginatedReviews.map(review => (
                <Card key={review._id} sx={{ mb: 2, backgroundColor:style.color4, color:'black' }}>
                  <CardContent>
                    <Box sx={{ display: "flex", flex:1, justifyContent: "left", alignItems: "center"}}>
                      <Typography sx={{fontSize:'1.3em'}}>{review.userName}</Typography>
                      <Rating value={review.starRating} readOnly precision={0.5} sx={{ml:2}}/>
                    </Box>

                    <Typography variant="caption" sx={{ color: style.color1, fontStyle: "italic", display: "block" }}>
                      {formatDate(review.createdAt)}
                    </Typography>

                    <Typography variant="body2" sx={{ mt: 0.5, mb:2, fontSize:'1em',backgroundColor:style.color4, color:'black' }}>{review.comment}</Typography>

                    <Box sx={{ display: "flex", gap: 1, mt: 1, backgroundColor:style.color4, }}>
                    <Tooltip title="Helpful">
                    <IconButton
                      size="small"
                      onClick={() => handleVote(review._id, "helpful")}
                    >
                      {user && (
                          <ThumbUpIcon
                          sx={{
                            color: review.foundHelpful.includes(user.id)
                              ? 'rgb(66, 135, 245)' // highlighted color
                              : style.color2, // default color
                            width:'30px',
                            height:'30px'
                          }}
                          />
                      )}
                       {!user && (
                      <ThumbUpIcon
                        sx={{
                          color: style.color2,
                          width:'30px',
                          height:'30px'
                        }}
                      />)}
                      <Typography variant="caption" sx={{fontSize:'0.8em', ml: 0.5 }}>
                        <strong>{review.helpfulCount}</strong>
                      </Typography>
                    </IconButton>
                  </Tooltip>
                      <Tooltip title="Not Helpful">
                        <IconButton
                      size="small"
                      onClick={() => handleVote(review._id, "not_helpful")}
                    >
                      {user && (
                        <ThumbDownIcon
                        sx={{
                          color: review.foundNotHelpful.includes(user.id)
                            ? 'rgb(66, 135, 245)' // highlighted color
                            : style.color2, // default color
                          width:'30px',
                          height:'30px'
                        }}
                      />

                      )}
                      {!user &&(
                        <ThumbDownIcon
                        sx={{
                          color: style.color2,
                          width:'30px',
                          height:'30px'
                        }}
                        />
                      )}
                     
                      <Typography variant="caption" sx={{fontSize:'0.8em', ml: 0.5 }}>
                        <strong>{review.notHelpfulCount}</strong>
                      </Typography>
                    </IconButton>
                      </Tooltip>
                    </Box>
                  </CardContent>
                </Card>
              ))
            )}

            {/* Pagination */}
            {totalPages > 1 && (
              <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
                <Pagination
                  count={totalPages}
                  page={currentPage}
                  onChange={(e, value) => setCurrentPage(value)}
                  color='primary'
                  sx={{color:style.color4}}
                />
              </Box>
            )}
          </Box>

          {/* Modals */}
          <SubscribeRedirectModal isOpen={isSubscribeRedirectModalOpen} close={closeModal(setSubscribeRedirectModalOpen)} />
          <LoginRegisterModal isOpen={isLoginRegisterModalOpen} close={closeModal(setLoginRegisterModalOpen)} loginComplete={loginCallback}/>
          <LeaveReviewModal sku={productSKU} isOpen={isLeaveReviewModalOpen} close={closeModal(setLeaveReviewModalOpen)} />

        </Box>
      )}
    </>
  );
}


